import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';
import Home from './pages/Home';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import AuthGuard from './containers/AuthGuard';

import { ReactComponent as UserIcon } from "./svgs/user.svg"
import { ReactComponent as PaintIcon } from "./svgs/paint.svg"
import { ReactComponent as FeaturesIcon } from "./svgs/diamond.svg"
import { ReactComponent as ChargeIcon } from "./svgs/charges.svg"
import Users from './pages/Home/Users';
import Theming from './pages/Home/Theming';
import Dialogs from './containers/Dialogs';
import Landing from './pages/Home/Landing';
import AppHome from './pages/Home/AppHome';
import Support from './pages/Home/Support';
import Features from './pages/Home/Features';
import Charging from './pages/Home/Charging';

export const PagesDefinition = [
    {id:"users", label: "Users", icon:UserIcon, element:<Users />, sub: null}, 
    
    {id:"customize", label: "Personalization", icon:PaintIcon, sub: [
      {id:"theming", label:"Theming", element:<Theming />},
      {id:"support", label:"Support Information", element:<Support />},
      {id:"landing", label:"Landing Screen", element:<Landing />},
      {id:"home", label:"Home Screen", element:<AppHome />}]}, 
    
    // {id:"templates", label: "Messaging", icon:MsgIcon, sub: [
    //   {id:"sms", label:"SMS Templates", element:<Templates />},
    //   {id:"email", label:"Email Templates ", element: <Templates sms={false} />},
    //   {id:"setup", label:"Configure", element:<Templates />}
    // ]},
           
    {id:"features", label: "Features", icon:FeaturesIcon, element:<Features />, sub: null},
    
    {id:"charging", label: "Charging", icon:ChargeIcon, element:<Charging />, sub: null}, 
    
    // {id:"maintenance", label: "Maintenance", icon:MainIcon, sub: [
    //   {id:"logs",label:"Logs", element:<></>},
    //   {id:"updates",label:"Updates", element:<></>}]}
    ]

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route
          path="/*"
          element={
            <AuthGuard>
              <Container className="main-container">
                <Home />
                <Dialogs />
              </Container>
            </AuthGuard>
          }
        />
        <Route path="/" element={<Navigate to="/users" replace />} />
      </Routes>
    </Router>
  );
}

export default App;